module.exports = __webpack_public_path__ + "static/media/018_intel3_6.b964af3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/intel/018_intel3_6.png
// module id = 488
// module chunks = 0